/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-08 14:25:43
 * @LastEditTime: 2025-09-04 10:06:45
 */
import React, { useState, useEffect } from "react";
import { Spin } from 'antd';
import { featureObject } from '../../type';
import detailIcon from '../../img/icon-detail.png';
import CarouselComponent from '@/components/like-carousel';
import arrowIcon from '../../img/line.png';
import { buyData,serviceSupport } from '../../config';
import './index.scss';
interface IProps {
  tabType: number,
  detailInfo: any
}
const IntroFeature: React.FC<IProps> = (props) => {
  const { detailInfo } = props;
  const [detailContent, setDetailContent] = useState<featureObject>();
  const [loading, setLoading] = useState(true);
 
  
  useEffect(() => {
    if (detailInfo) {
      const getDetail: featureObject = {
        basis: {},
        feature: {},
        params: {},
        structure: [],
        scene: [],
        intro: [],
        service: {},
      };
      (detailInfo.pmsProductAttributeDetails ?? []).forEach((cData: any) => {
        switch (cData.type) {
          case 1:
            getDetail.basis = cData;
            break
          case 2:
            getDetail.feature = cData;
            break
          case 3:
            getDetail.params = cData;
            break
          case 4:
            getDetail.structure = cData;
            break
          case 5:
            getDetail.scene = cData;
            break
          case 6:
            getDetail.intro = cData;
            break
          case 8: //api、SDK
            getDetail.service = cData;
            break
        }
      })
      setDetailContent(getDetail);
      setLoading(false);
    }

  }, [detailInfo]);
  console.log(detailContent?.service?.story,'stoey')
  return (
    <>
      {
        loading ?
          <Spin size="large" /> :
          <div className="feature-content">
            <div className='introfeature-main'>
              <div className="basis-content feature-list">
                <h2><img src={detailIcon} alt='' />基础介绍</h2>
                <div className="basis-intro">
                  <div className="intro-text" title={detailContent?.basis?.story}>{detailContent?.basis?.story}</div>
                  <img src={detailInfo.pmsFiles?.length > 0 ? detailInfo.pmsFiles[0]?.url : ''} alt='' />
                </div>
              </div>
              {
                JSON.parse(detailContent?.feature?.story ?? '[]').length > 0 &&
                <div className='productList-main feature-list'>
                  <div className="product-feature">
                    <h2><img src={detailIcon} alt='' />产品特点</h2>
                    <ul>
                      {
                        JSON.parse(detailContent?.feature?.story).map((fRes: any, index: number) => (
                          <li key={index} title={fRes} className={`${JSON.parse(detailContent?.feature?.story).length > 1 && 'feature-name'}`}>
                            <i></i><span>{fRes}</span>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                </div>
              }
              {
                ((detailInfo.product?.productType === 3||detailInfo.product?.productType === 1 )&& detailContent?.params?.story) &&
                <div className="product-params feature-list">
                  <h2><img src={detailIcon} alt='' />产品参数</h2>
                  <div className="table-content" dangerouslySetInnerHTML={{ __html: detailContent?.params?.story }} />
                </div>
              }
              {
                (detailInfo.product?.productType === 2 && JSON.parse(detailContent?.intro?.story ?? '[]').length > 0) &&
                <div className="func-intro feature-list">
                  <h2><img src={detailIcon} alt='' />功能介绍</h2>
                  <div className="intro-list">
                    {
                      JSON.parse(detailContent?.intro?.story).map((fRes: any, index: number) => (
                        <div key={index} className="intro-list-content">
                          <div className={`${JSON.parse(fRes).url && 'intro-left'}`} dangerouslySetInnerHTML={{ __html: JSON.parse(fRes).text }} />
                          {
                            JSON.parse(fRes).url &&
                            <img src={JSON.parse(fRes).url} alt='' />
                          }
                        </div>
                      ))
                    }
                  </div>
                </div>
              }
              {
                (detailInfo.product?.productType === 1 && JSON.parse(detailContent?.structure?.story ?? '[]').length > 0) &&
                <div className='productList-main feature-list'>
                  <div className="product-feature">
                    <h2><img src={detailIcon} alt='' />产品结构</h2>
                    <ul>
                      {
                        JSON.parse(detailContent?.structure?.story).map((sRes: any, index: number) => (
                          <li key={index} title={sRes} className={`${JSON.parse(detailContent?.structure?.story).length > 1 && 'feature-name'}`}>
                            <i></i><span>{sRes}</span>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                </div>
              }
              {
                JSON.parse(detailContent?.scene?.story ?? '[]').length > 0 &&
                <div className="apply-scene-hard feature-list productList-main" >
                  <div className="product-feature">
                    <h2><img src={detailIcon} alt='' />应用场景</h2>
                    <ul>
                      {
                        JSON.parse(detailContent?.scene?.story).map((sRes: any, index: number) => (
                          <li key={index} className={`${JSON.parse(detailContent?.scene?.story).length > 1 && 'scene-content'}`}>
                            <i></i><span dangerouslySetInnerHTML={{ __html: sRes }}></span>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                </div>
              }
              {
                detailInfo?.product?.productType===3&&
                <div className="apply-scene-hard feature-list productList-main buy-process" >
                  <div className="product-feature">
                    <h2><img src={detailIcon} alt='' />使用流程</h2>
                    <div className="buy-content">
                      {buyData.map((item:any, index:number) => {
                        return (
                            <div className="buy-item" key={index}>
                              <div className="buy-item-pic">{ index+1}</div>
                              {index < 4 && <img src={arrowIcon } alt="" className="buy-item-arrow" />}
                            </div>
                        )
                      })}

                    </div>
                    <div className="buy-content1">
                      {buyData.map((item1, index) => {
                        return (
                          <React.Fragment key={index}>
                            <div dangerouslySetInnerHTML={{__html:item1.title}} className={`buy-item-title title${index}`}></div>
                          </React.Fragment>
                        )
                      })}

                    </div>
                  </div>
                </div>
              }
              {
                detailContent?.service?.story&&
                <div className="apply-scene-hard feature-list productList-main buy-process1" >
                  <div className="product-feature">
                    <h2><img src={detailIcon} alt='' />服务支持</h2>
                      <div className="service-support">
                        {serviceSupport.map(item => { 
                          return (
                            <div className="service-item" key={item.id}>
                              <div className="service-title">{item.title}</div>
                              {item.type === 1 ? <img src={item.icon} alt='docs' className="service-icon" onClick={() => { window.open(detailContent?.service?.story)}}/> :
                                <div className="service-desc">
                                {/* <p>{item.desc1}</p> */}
                                  {item.link ? <p className="service-link">
                                    <a href={item.link} dangerouslySetInnerHTML={{__html:item.desc1}} target="_blank" rel="noreferrer"></a>
                                  </p> : <p dangerouslySetInnerHTML={{__html:item.desc1??''}}></p>}
                                </div>
                              }
                            </div>
                          )
                        })}
                      </div>
                  </div>
                </div>
              }
            </div>
            <div className="recommend-show">
              <CarouselComponent mode='mini' />
            </div>
          </div>
      }
    </>
  )
}

export default IntroFeature;